import { ASSETS_ARTICLES } from './assets';
import { BILLING_ARTICLES } from './billing';
import { GETTING_STARTED_ARTICLES } from './getting-started';
import { PATIENTS_ARTICLES } from './patients';
import { PRIVACY_ARTICLES } from './privacy';
import { REPORTS_ARTICLES } from './reports';
import { TESTS_ARTICLES } from './tests';
import { TOOLS_ARTICLES } from './tools';
import type { HelpArticle, HelpTopicId } from '../types';

export const HELP_ARTICLES: HelpArticle[] = [
    ...GETTING_STARTED_ARTICLES,
    ...REPORTS_ARTICLES,
    ...PATIENTS_ARTICLES,
    ...TESTS_ARTICLES,
    ...ASSETS_ARTICLES,
    ...TOOLS_ARTICLES,
    ...BILLING_ARTICLES,
    ...PRIVACY_ARTICLES,
];

export function getArticlesByTopic(topicId: HelpTopicId): HelpArticle[] {
    return HELP_ARTICLES.filter((article) => article.topicId === topicId);
}

export function findHelpArticle(topicId: string, slug: string): HelpArticle | undefined {
    return HELP_ARTICLES.find((article) => article.topicId === topicId && article.slug === slug);
}

function normalize(value: string): string {
    return value
        .toLowerCase()
        .normalize('NFD')
        .replace(/\p{Diacritic}/gu, '');
}

export function searchHelpArticles(query: string): HelpArticle[] {
    const term = normalize(query.trim());
    if (!term) return [];

    return HELP_ARTICLES.filter((article) => {
        const haystack = normalize(
            [article.title, article.description, ...article.keywords].join(' '),
        );
        return term.split(/\s+/).every((word) => haystack.includes(word));
    });
}
